// Offline snapshot key scheme for a downloaded inspection. Keys are split so
// each local write rewrites a small row rather than one multi-MB blob.

export const inspectionContextKey = (inspectionId: number): string =>
  `inspection:${inspectionId}`;

/** Parses the inspection id back out of `inspection:{id}` context keys. */
export const parseInspectionContextKey = (
  contextKey: string | undefined
): number | undefined => {
  if (!contextKey) return undefined;
  const match = /^inspection:(\d+)$/.exec(contextKey);
  return match ? Number(match[1]) : undefined;
};

export const isInspectionContextKey = (
  contextKey: string | undefined
): boolean => parseInspectionContextKey(contextKey) !== undefined;

export const inspectionSnapshotKeys = {
  meta: (inspectionId: number): string => `inspection:${inspectionId}:meta`,
  devices: (inspectionId: number): string =>
    `inspection:${inspectionId}:devices`,
  definitions: (inspectionId: number): string =>
    `inspection:${inspectionId}:definitions`,
  history: (inspectionId: number, deviceId: number | string): string =>
    `inspection:${inspectionId}:history:${deviceId}`,
  /** Locally recorded compliance/values/comments/photos for one device. */
  entry: (inspectionId: number, deviceId: number | string): string =>
    `inspection:${inspectionId}:entry:${deviceId}`,
};

/** Prefix of every locally-recorded entry snapshot for an inspection. */
export const inspectionEntryKeyPrefix = (inspectionId: number): string =>
  `inspection:${inspectionId}:entry:`;

/** Pristine copy of a mutable snapshot, captured at download for replay rebuild. */
export const baseSnapshotKey = (key: string): string => `base:${key}`;
